import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatDateForSessionCard } from '../utils/other';
import UserBookedCourtCardComponent from '../components/UserBookedCourtCardComponent';
import { openModal } from '../actions/modalsActions';
import { modals } from '../utils/constants';
import ApiClient from '../utils/apiClient';

class UserBookedCourtCardContainer extends React.Component {
  constructor(props) {
    super(props);

    this.openCancellationConfirmModal = this.openCancellationConfirmModal.bind(
      this
    );
    this.confirmAction = this.confirmAction.bind(this);
  }

  confirmAction(event_id) {
    return () => ApiClient.post(`/api/v1/cancel-court-booking/${event_id}/`);
  }

  openCancellationConfirmModal() {
    this.props.openModal(modals.CANCELLATION_CONFIRM, {
      confirmAction: this.confirmAction(this.props.courtEventId),
      refreshAction: this.props.refreshAction,
      translationNamespace: 'courtCancel'
    });
  }

  render() {
    const {
      startTime,
      eventDate,
      clubName,
      clubAddress,
      courtType,
      refreshAction,
      invitedBy
    } = this.props;
    return (
      <UserBookedCourtCardComponent
        time={ formatDateForSessionCard(startTime, eventDate) }
        clubName={ clubName }
        clubAddress={ clubAddress }
        courtType={ courtType }
        refreshAction={ refreshAction }
        openCancellationConfirmModal={ this.openCancellationConfirmModal }
        invitedBy={ invitedBy }
      />
    );
  }
}

UserBookedCourtCardContainer.propTypes = {
  courtEventId: PropTypes.number,
  eventDate: PropTypes.string,
  startTime: PropTypes.string,
  clubName: PropTypes.string,
  clubAddress: PropTypes.string,
  courtType: PropTypes.string,
  refreshAction: PropTypes.func.isRequired,
  invitedBy: PropTypes.string
};

UserBookedCourtCardContainer.defaultProps = {
  courtEventId: null,
  eventDate: '',
  startTime: '',
  clubName: '',
  clubAddress: '',
  courtType: '',
  invitedBy: ''
};

const mapDispatchToProps = dispatch => ({
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData)),
  dispatch
});

export default connect(null, mapDispatchToProps)(UserBookedCourtCardContainer);



// WEBPACK FOOTER //
// ./src/containers/UserBookedCourtCardContainer.js